<div class="relatorio-desempenho-container">
    <div class="card">
        <h2>Relatório de Desempenho</h2>
        
        <div class="filtros-section mb-4">
            <div class="grid">
                <div class="col-12 md:col-6">
                    <label for="tipoRelatorio" class="block mb-2">Tipo de Relatório *</label>
                    <p-dropdown 
                        id="tipoRelatorio"
                        [(ngModel)]="tipoRelatorio" 
                        [options]="[
                            {label: 'Geral', value: 'geral'},
                            {label: 'Estações', value: 'estacoes'},
                            {label: 'Cliente', value: 'cliente'}
                        ]"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Selecione o tipo"
                        (onChange)="onTipoRelatorioChange()"
                        styleClass="w-full">
                    </p-dropdown>
                </div>

                <div class="col-12 md:col-6" *ngIf="tipoRelatorio === 'estacoes'">
                    <label for="estacoes" class="block mb-2">Selecione as Estações *</label>
                    <p-multiSelect 
                        id="estacoes"
                        [(ngModel)]="estacoesSelecionadas" 
                        [options]="dropDownEstacoes"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Selecione as estações"
                        [filter]="true"
                        filterLocale="pt-BR"
                        appendTo="body"
                        [panelStyle]="{'max-width': '400px', 'width': '100%'}"
                        styleClass="w-full">
                    </p-multiSelect>
                </div>

                <div class="col-12 md:col-6" *ngIf="tipoRelatorio === 'cliente'">
                    <label for="clientes" class="block mb-2">Selecione os Clientes *</label>
                    <p-multiSelect 
                        id="clientes"
                        [(ngModel)]="clientesSelecionados" 
                        [options]="dropDownClientes"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Selecione os clientes"
                        [filter]="true"
                        appendTo="body"
                        [panelStyle]="{'max-width': '400px', 'width': '100%'}"
                        styleClass="w-full">
                    </p-multiSelect>
                </div>

                <div class="col-12 md:col-3">
                    <label for="dataInicial" class="block mb-2">Data Inicial *</label>
                    <p-datepicker 
                        id="dataInicial"
                        [(ngModel)]="dataInicial" 
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [maxDate]="dataFinal"
                        placeholder="Selecione a data inicial"
                        styleClass="w-full">
                    </p-datepicker>
                </div>

                <div class="col-12 md:col-3">
                    <label for="dataFinal" class="block mb-2">Data Final *</label>
                    <p-datepicker 
                        id="dataFinal"
                        [(ngModel)]="dataFinal" 
                        [showIcon]="true"
                        dateFormat="dd/mm/yy"
                        [minDate]="dataInicial"
                        placeholder="Selecione a data final"
                        styleClass="w-full">
                    </p-datepicker>
                </div>

                <div class="col-12 md:col-6 flex align-items-end gap-2">
                    <button 
                        pButton 
                        pRipple 
                        type="button" 
                        label="Gerar Relatório" 
                        icon="pi pi-search"
                        class="p-button-primary"
                        (click)="gerarRelatorio()"
                        [disabled]="loading || loadingPdfDiario">
                    </button>
                    <button 
                        pButton 
                        pRipple 
                        type="button" 
                        label="PDF Diário" 
                        icon="pi pi-calendar"
                        class="p-button-warning"
                        (click)="exportarPDFDiario()"
                        [disabled]="loading || loadingPdfDiario"
                        pTooltip="Exibe os índices diários em uma grade · máx. 32 dias"
                        tooltipPosition="top">
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="loading || loadingPdfDiario" class="loading-container flex justify-content-center align-items-center mb-4">
            <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="8"
                fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
            <span class="ml-3">{{ loadingPdfDiario ? 'Gerando relatório diário...' : 'Gerando relatório...' }}</span>
        </div>

        <div *ngIf="(tipoResultado === 'padrao' && relatorioData && !loading) || (tipoResultado === 'diario' && relatorioDiarioData && !loadingPdfDiario)" class="relatorio-section">
            <div class="flex justify-content-between align-items-center mb-3">
                <h3>{{ tipoResultado === 'diario' ? 'Resultado do Relatório Diário' : 'Resultado do Relatório' }}</h3>
                <div>
                    <button *ngIf="tipoResultado === 'diario'"
                        pButton pRipple type="button"
                        [label]="exportingPdfDiario ? 'Exportando...' : 'Exportar PDF Diário'"
                        icon="pi pi-file-pdf"
                        class="p-button-danger"
                        (click)="exportarRelatorioPDFDiario()"
                        [disabled]="exportingPdfDiario">
                    </button>
                    <ng-container *ngIf="tipoResultado === 'padrao'">
                    <button 
                        pButton 
                        pRipple 
                        type="button" 
                        label="Exportar XLSX" 
                        icon="pi pi-file-excel"
                        class="p-button-success mr-2"
                        (click)="exportarXLSX()">
                    </button>
                    <button 
                        pButton 
                        pRipple 
                        type="button" 
                        label="Exportar PDF" 
                        icon="pi pi-file-pdf"
                        class="p-button-danger"
                        (click)="exportarPDF()">
                    </button>
                    </ng-container>
                </div>
            </div>

            <div *ngIf="tipoResultado === 'padrao'" class="periodo-info mb-3">
                <strong>Período:</strong> 
                {{ dataInicial | date:'dd/MM/yyyy' }} a {{ dataFinal | date:'dd/MM/yyyy' }}
            </div>

            <ng-container *ngIf="tipoResultado === 'diario'">
                <div class="periodo-info mb-3">
                    <strong>Período:</strong>
                    {{ relatorioDiarioData.periodo?.data_inicial | date:'dd/MM/yyyy' }} a
                    {{ relatorioDiarioData.periodo?.data_final | date:'dd/MM/yyyy' }}
                </div>

                <div class="resumo-geral mb-4" *ngIf="relatorioDiarioData.resumo as resumo">
                    <h4>Resumo Geral</h4>
                    <div class="grid">
                        <div class="col-12 md:col-4"><strong>Total de Estações:</strong> {{ resumo.total_estacoes }}</div>
                        <div class="col-12 md:col-4"><strong>Média Geral de Coleta:</strong> {{ resumo.media_coleta_geral | number:'1.0-0' }}%</div>
                        <div class="col-12 md:col-4"><strong>Média Geral de Integração:</strong> {{ resumo.media_integracao_geral | number:'1.0-0' }}%</div>
                    </div>
                </div>

                <div class="daily-legend mb-3">
                    <span><strong>Valores por dia:</strong> Coleta / Integração (%)</span>
                    <span class="daily-legend-item"><i class="daily-color daily-color-good"></i> Integração acima de 90%</span>
                    <span class="daily-legend-item"><i class="daily-color daily-color-medium"></i> Integração de 80% a 90%</span>
                    <span class="daily-legend-item"><i class="daily-color daily-color-low"></i> Integração abaixo de 80%</span>
                </div>

                <div *ngIf="!relatorioDiarioData.clientes?.length" class="empty-daily-result">
                    Nenhum dado encontrado para o período selecionado.
                </div>

                <div *ngFor="let cliente of relatorioDiarioData.clientes" class="cliente-section mb-4">
                    <div class="cliente-header mb-2">
                        <h4>{{ cliente.cliente_nome }}</h4>
                        <div class="grid">
                            <div class="col-12 md:col-4"><strong>Média de Coleta:</strong> {{ cliente.media_coleta | number:'1.0-0' }}%</div>
                            <div class="col-12 md:col-4"><strong>Média de Integração:</strong> {{ cliente.media_integracao | number:'1.0-0' }}%</div>
                            <div class="col-12 md:col-4"><strong>Total de Estações:</strong> {{ cliente.total_estacoes }}</div>
                        </div>
                    </div>

                    <div class="daily-table-wrapper">
                        <p-table [value]="cliente.estacoes || []" [paginator]="cliente.estacoes?.length > 10" [rows]="10"
                            [scrollable]="true" styleClass="p-datatable-sm daily-performance-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th class="daily-station-column">Estação</th>
                                    <th *ngFor="let dia of relatorioDiarioData.dias" class="daily-date-column">{{ formatarDia(dia) }}</th>
                                    <th class="daily-average-column">Média</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-estacao>
                                <tr>
                                    <td class="daily-station-column">{{ estacao.estacao_nome }}</td>
                                    <td *ngFor="let dia of relatorioDiarioData.dias" class="daily-date-column"
                                        [ngStyle]="{'background-color': corFundoIntegracaoParaTela(estacao.dias?.[dia]?.indice_integracao || 0)}">
                                        <div class="daily-index-value">{{ (estacao.dias?.[dia]?.indice_coleta || 0) | number:'1.0-0' }}%</div>
                                        <div class="daily-index-value">{{ (estacao.dias?.[dia]?.indice_integracao || 0) | number:'1.0-0' }}%</div>
                                    </td>
                                    <td class="daily-average-column">
                                        <div class="daily-index-value">{{ estacao.media_coleta | number:'1.0-0' }}%</div>
                                        <div class="daily-index-value">{{ estacao.media_integracao | number:'1.0-0' }}%</div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr><td [attr.colspan]="relatorioDiarioData.dias.length + 2" class="text-center">Nenhuma estação encontrada</td></tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </ng-container>

            <div *ngIf="tipoResultado === 'padrao' && relatorioData.resumo" class="resumo-geral mb-4">
                <h4>Resumo Geral</h4>
                <div class="grid">
                    <div class="col-12 md:col-4">
                        <strong>Total de Estações:</strong> {{ relatorioData.resumo.total_estacoes }}
                    </div>
                    <div class="col-12 md:col-4">
                        <strong>Média Geral de Coleta:</strong> {{ relatorioData.resumo.media_coleta_geral?.toFixed(2) }}%
                    </div>
                    <div class="col-12 md:col-4">
                        <strong>Média Geral de Integração:</strong> {{ relatorioData.resumo.media_integracao_geral?.toFixed(2) }}%
                    </div>
                </div>
            </div>

            <!-- Relatório por Cliente -->
            <div *ngIf="tipoResultado === 'padrao' && tipoRelatorio === 'cliente' && relatorioData.data">
                <div *ngFor="let cliente of relatorioData.data" class="cliente-section mb-4">
                    <div class="cliente-header mb-2">
                        <h4>{{ cliente.cliente_nome }}</h4>
                        <div class="grid">
                            <div class="col-12 md:col-4">
                                <strong>Média de Coleta:</strong> {{ cliente.media_coleta?.toFixed(2) }}%
                            </div>
                            <div class="col-12 md:col-4">
                                <strong>Média de Integração:</strong> {{ cliente.media_integracao?.toFixed(2) }}%
                            </div>
                            <div class="col-12 md:col-4">
                                <strong>Total de Estações:</strong> {{ cliente.total_estacoes }}
                            </div>
                        </div>
                    </div>

                    <p-table 
                        [value]="cliente.estacoes || []" 
                        [paginator]="true" 
                        [rows]="10"
                        [responsive]="true"
                        styleClass="p-datatable-sm">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Estação</th>
                                <th>Índice de Coleta (%)</th>
                                <th>Índice de Integração (%)</th>
                                <th>Intervalo Operação (min)</th>
                                <th>Dias em Monitoramento</th>
                                <th>Integrações</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-estacao>
                            <tr>
                                <td>{{ estacao.estacao_nome }}</td>
                                <td>{{ estacao.indice_coleta?.toFixed(2) || '0.00' }}</td>
                                <td>{{ estacao.indice_integracao_medio?.toFixed(2) || '0.00' }}</td>
                                <td>{{ estacao.intervalo_operacao || '-' }}</td>
                                <td>{{ estacao.dias_em_monitoramento || 0 }}</td>
                                <td>
                                    <div *ngIf="estacao.integracoes && estacao.integracoes.length > 0">
                                        <div *ngFor="let integracao of estacao.integracoes" class="mb-1">
                                            <small>
                                                <strong>{{ integracao.configuracao_integracao_nome }}:</strong> 
                                                {{ integracao.indice?.toFixed(2) }}% 
                                                ({{ integracao.envios_realizados }}/{{ integracao.total_esperado }})
                                            </small>
                                        </div>
                                    </div>
                                    <span *ngIf="!estacao.integracoes || estacao.integracoes.length === 0">-</span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="6" class="p-text-center">Nenhuma estação encontrada</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>

            <!-- Relatório Geral ou por Estações -->
            <div *ngIf="tipoResultado === 'padrao' && tipoRelatorio !== 'cliente' && relatorioData.data">
                <p-table 
                    [value]="relatorioData.data" 
                    [paginator]="true" 
                    [rows]="10"
                    [responsive]="true"
                    styleClass="p-datatable-sm">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Estação</th>
                            <th>Cliente</th>
                            <th>Índice de Coleta (%)</th>
                            <th>Índice de Integração (%)</th>
                            <th>Intervalo Operação (min)</th>
                            <th>Dias em Monitoramento</th>
                            <th>Integrações</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-estacao>
                        <tr>
                            <td>{{ estacao.estacao_nome }}</td>
                            <td>{{ estacao.cliente_nome || '-' }}</td>
                            <td>{{ estacao.indice_coleta?.toFixed(2) || '0.00' }}</td>
                            <td>{{ estacao.indice_integracao_medio?.toFixed(2) || '0.00' }}</td>
                            <td>{{ estacao.intervalo_operacao || '-' }}</td>
                            <td>{{ estacao.dias_em_monitoramento || 0 }}</td>
                            <td>
                                <div *ngIf="estacao.integracoes && estacao.integracoes.length > 0">
                                    <div *ngFor="let integracao of estacao.integracoes" class="mb-1">
                                        <small>
                                            <strong>{{ integracao.configuracao_integracao_nome }}:</strong> 
                                            {{ integracao.indice?.toFixed(2) }}% 
                                            ({{ integracao.envios_realizados }}/{{ integracao.total_esperado }})
                                        </small>
                                    </div>
                                </div>
                                <span *ngIf="!estacao.integracoes || estacao.integracoes.length === 0">-</span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7" class="p-text-center">Nenhum dado encontrado</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>

